export const fixedCacheKeys = {
  LOGIN: "user-login-post",
  ADMIN_REGISTRATION: "admin-registration-post",
  SEND_OTP: "user-otp-post",
  VERIFY_OTP: "user-verify-post",
  LOGOUT: "user-verify-get",
  FORGOT_PASSWORD: "user-forgotPassword-post",
  RESET_PASSWORD: "user-resetPassword-post",
  RESET_USER_PASSWORD: "user-resetUserPassword-post",
  EDIT_PROFILE: "user-profileData-Post",
  // USER_PROFILE: "user-profile-get",
  DELETE_USER_ACCOUNT: "user-deleteUserAccount-post",
  FILE_UPLOAD: "user-File-post",
  CHANGE_PASSWORD: "user-changePassword-post",
  DELETE_PROFILE: "user-deleteProfile-delete",
  ADD_META_DATA: "user-addMetaData-post",
  EDIT_META_DATA: "user-editMetaDta-put",
  EDIT_SITE_SETTING_DATA: "user-editSiteSettingData-put",
  EDIT_ANALYTICAL_DATA: "user-editAnalyticalData-put",
  ADD_SITE_DATA: "user-addSiteData-Post",
  ADD_ANALYTICAL_DATA: "user-addAnalyticalData-post",
  ADD_MAINTENANCE_DATA: "user-editMaintenanceData-post",
  EDIT_MAINTENANCE_DATA: "user-editMaintenanceData-put",
  DATE_TIME: "user-dateTime-Post",
  EDIT_DATE_TIME: "user-dateTime-put",
  ADD_SOCIAL_MEDIA_SDK: "user-addSocialMediaSdk-post",
  EDIT_SOCIAL_MEDIA_SDK: "user-editSocialMediaSdk-put",
  ADD_SOCIAL_MEDIA_LINK: "user-addSocialMediaLink-post",
  EDIT_SOCIAL_MEDIA_LINK: "user-editSocialMediaLink-put",
  CHANGE_STATUS: "user-changeStatus-post",
  ADD_SMTP_DETAILS: "user-addSmtpDetails-post",
  EDIT_SMTP_DETAILS: "user-editSmtpDetails-put",
  ADD_SMS_DETAILS: "user-addSmsDetails-post",
  EDIT_SMS_DETAILS: "user-editSmsDetails-put",
  NOTIFICATION_STATUS: "setting-notificationStatus-post",
  ADD_PAYMENT_DETAILS: "setting-paymentData-post",
  EDIT_PAYMENT_DETAILS: "setting-paymentData-put",
  TIMEZONE_LIST: "country-timezoneList-post",
  TIMEZONE_DELETE: "country-timeZoneData-delete",
  ADD_TIMEZONE: "country-addTimezone-post",
  TIMEZONE_CHANGE_STATUS: "timezone-changeStatus-post",
  COUNTRY_LIST: "country-list-post",
  COUNTRY_LIST_DELETE: "country-list-delete",
  COUNTRY_LIST_CHANGE_STATUS: "country-list-changeStatus-patch",
  ADD_COUNTRYLIST: "country-addCountryList-post",
  LANGUAGE_MESSAGES: "language-messages-post",
  ADD_LANGUAGE_MESSAGES: "language-addMessages-post",
  LANGUAGE_LABEL: "language-label-post",
  ADD_LANGUAGE_LABEL: "language-addEditLabel-post",
  EDIT_LANGUAGE_LABEL: "language-editLabel-put",
  LANGUAGE_LIST: "country-language-post",
  LANGUAGE_LIST_CHANGE_STATUS: "language-list-changeStatus-patch",
  ADD_LANGUAGELIST: "country-addLanguageList-post",
  ADD_ROLE: "role-addRole-post",
  EDIT_ROLE: "role-editRole-put",
  ROLE_LIST: "role-roleList-post",
  CHANGE_ROLE: "role-changeRole-patch",
  DELETE_ROLE: "role-deleteRole-delete",
  USER_LIST: "role-usersList-get",
  EMAIL_TEMPLATES_LISTINGS: "email-emailTemlates-post",
  EMAIL_TEMPLATES_STATUS_CHANGE: "email-emailTemplatesStatus-post",
  EMAIL_TEMPLATES_DELETE: "email-emailTemplatesDelete-delete",
  EMAIL_TEMPLATES_ADD: "email-addEmailTemplates-post",
  EMAIL_TEMPLATES_EDIT: "email-editEmailTemplates-post",
  BLOG_CATEGORY_LISTING: "blog-blogCategoryListing-post",
  BLOG_CATEGORY_STATUS: "blog-blogCategoryStatus-post",
  BLOG_CATEGORY_DELETE: "blog-blogCategoryDelete-post",
  BLOG_CATEGORY_ADD: "blog-blogCategoryAdd-post",
  BLOG_CATEGORY_EDIT: "blog-blogCategoryEdit-post",
  BLOG_CATEGORY_LIST_DOWNLOAD: "blog-blogCategoriesDownload-get",
  BLOG_LIST: "blog-blogList-post",
  BLOG_ADD_LIST: "blog-blogAddEditList-post",
  BLOG_EDIT_LIST: "blog-blogEdit-post",
  BLOG_DELETE: "blog-blogDelete-delete",
  BLOG_PUBLISH: "blog-blogPublishStatusChange-patch",
  BLOG_LIST_DOWNLOAD: "blog-blogDownload-get",
  //faqCategory
  FAQ_CATEGORY_LISTING: "faq-faqCategoryListing-get",
  FAQ_CATEGORY_DELETE: "faq-faqCategoryDelete-delete",
  FAQ_CATEGORY_ADD: "faq-faqCategoryAdd-post",
  FAQ_CATEGORY_EDIT: "faq-faqCategoryEdit-put",
  FAQ_CATEGORY_DETAILS: "faq-faqCategoryDetails-get",
  FAQ_CATEGORY_STATUS_DETAILS: "faq-faqCategoryStatus-patch",
  //faq
  FAQ_LISTING: "faq-faqListing-get",
  FAQ_DELETE: "faq-faqDelete-delete",
  FAQ_ADD: "faq-faqAdd-post",
  FAQ_EDIT: "faq-faqEdit-put",
  FAQ_DETAILS: "faq-faqDetails-get",
  FAQ_STATUS_CHANGE: "faq-faqStatusChange-patch",

  //User data
  USER_DATA: "users-UsersData-get",
  DELETE_USER_DATA: "users-deleteUsersData-delete",
  CHANGE_USER_STATUS: "users-changeUsersStatus-post",
  UPDATE_USER_STATUS: "users-updateUsersStatus-put",
  STATUS_ADMIN_USER_DATA: "users-statusAdminUsersData-post",
  USER_DETAILS_DOWNLOAD: "users-userDetailsDownload-get",
  //static page
  STATIC_PAGE_LISTING: "static-staticPageListing-post",
  STATIC_PAGE_CHANGE_STATUS: "static-staticPageChangeStatus-post",
  ADD_STATIC_PAGES: "static-addStaticPages-post",
  EDIT_STATIC_PAGES: "static-editStaticPages-post",
  DELETE_STATIC_PAGES: "static-deleteStaticPages-delete",
  STATIC_PAGE_LIST_DOWNLAOD: "static-staticpageDownload-get",
  //filter
  SAVE_FILTER_DATA: "filter-saveFilter-post",
  GET_FILTER_DATA: "filter-getFilter-post",
  DELETE_FILTER_DATA: "filter-deleteFilter-delete",
  SAVE_COLUMN_DATA: "column-saveColumn-post",
  GET_COLUMN_DATA: "column-getColumn-post",
  DELETE_COLUMN_DATA: "column-deleteColumn-delete",
  //support
  SUPPORT_LISTING: "support-getSupportList-get",
  SUPPORT_DELETE: "support-deleteSupport-delete",
  SUPPORT_STATUS: "support-ticketStatus-patch",
  SUPPORT_ADD_DATA: "support-addSupportData-post",
  SUPPORT_EDIT_DATA: "support-editReplyData-put",
  SUPPORT_REPLY_DELETE: "support-deleteReplyData-delete",

  //city
  ADD_CITY_DATA: "city-addCityData-post",
  CITY_LIST: "city-cityList-post",
  CHANGE_CITY: "city-changeCity-patch",
  CITY_DROPDOWN: "city-dropdownCity-get",
  EDIT_CITY_DETAILS: "city-editCityDetails-put",
  DELETE_CITY: "zones-deleteCity-delete",
  //club type
  ADD_CLUB_TYPE_DATA: "clubType-addClubTypeData-post",
  CLUB_TYPE_LIST: "clubType-clubTypeList-post",
  CHANGE_CLUB_TYPE: "clubType-changeClubType-patch",
  EDIT_CLUB_TYPE_DETAILS: "clubType-editClubTypeDetails-put",
  DELETE_CLUB_TYPE: "clubType-deleteClubType-delete",
  //zones
  ADD_ZONES_DATA: "zones-addZonesData-post",
  ZONES_LIST: "zones-ZonesList-post",
  CHANGE_ZONES: "zones-changeZones-patch",
  EDIT_ZONES_DETAILS: "zones-editZonesDetails-put",
  DELETE_ZONES: "zones-deleteZones-delete",
  ZONES_DETAILS_DROPDOWN: "zones-dropdownZones-get",

  //Drink type
  ADD_DRINK_TYPE_DATA: "drinkType-addDrinkTypeData-post",
  DRINK_TYPE_LIST: "drinkType-drinkTypeList-post",
  CHANGE_DRINK_TYPE: "drinkType-changeDrinkType-patch",
  EDIT_DRINK_TYPE_DETAILS: "drinkType-editDrinkTypeDetails-put",
  DELETE_DRINK_TYPE: "drinkType-deleteDrinkType-delete",
  DRINK_TYPE_DROPDOWN: "drinkType-drinkTypedropdown-get",

  //Music type
  ADD_MUSIC_TYPE_DATA: "musicType-addMusicTypeData-post",
  MUSIC_TYPE_LIST: "musicType-musicTypeList-post",
  CHANGE_MUSIC_TYPE: "musicType-changeMusicType-patch",
  EDIT_MUSIC_TYPE_DETAILS: "musicType-editMusicTypeDetails-put",
  DELETE_MUSIC_TYPE: "musicType-deleteMusicType-delete",
  DROPDOWN_MUSIC_TYPE: "musicType-dropdownMusicType-get",
  // outfits
  ADD_OUTFITS_DATA: "outfits-addOutfitsData-post",
  OUTFITS_LIST: "outfits-outfitsList-post",
  CHANGE_OUTFITS: "outfits-changeOutfits-patch",
  EDIT_OUTFITS_DETAILS: "outfits-editOutfitsDetails-put",
  DELETE_OUTFITS: "outfits-deleteOutfits-delete",
  OUTFITS_DROPDOWN: "outfits-dropdownOutfits-get",
  //plans
  ADD_PLANS_DATA: "plans-addPlansData-post",
  PLANS_LIST: "plans-plansList-post",
  CHANGE_PLANS: "plans-changePlans-patch",
  PIN_PLAN: "plans-pinPlans-put",
  UNPIN_PLAN: "plans-unPinPlans-put",
  DELETE_PLANS: "plans-deletePlans-delete",
  EDIT_PLANS: "plans-editPlans-put",
  FILE_UPLOAD_PLANS: "plans-uploadFilePlans-post",
  DROPDOWN_PLAN: "plans-dropdownPlan-get",
  // category ==> levels
  ADD_LEVELS_DATA: "Levels-addLevelData-post",
  LEVELS_LIST: "Levels-LevelsList-post",
  CHANGE_LEVELS: "levels-changeLevels-patch",
  DELETE_LEVELS: "levels-deleteLevels-delete",
  EDIT_LEVELS: "levels-editLevels-put",
  GET_LEVELS_POINTS: "levels-getPointLevels-get",

  //caregory ==> SuperLevels
  ADD_SUPER_LEVELS_DATA: "superLevels-addSuperLevelsData-post",
  SUPER_LEVELS_LIST: "superLevels-SuperLevelsList-post",
  CHANGE_SUPER_LEVELS: "superLevels-changeSuperLevels-patch",
  DELETE_SUPER_LEVELS: "superLevels-deleteSuperLevels-delete",
  EDIT_SUPER_LEVELS: "superLevels-editSuperLevels-put",
  GET_SUPER_LEVELS_POINTS: "superLevels-getPointSuperLevels-get",

  //caregory ==> actions
  ADD_ACTIONS_DATA: "actions-addActionsData-post",
  EDIT_CLUB_ACTIONS: "actions-editClubActions-put",
  ACTIONS_LIST: "actions-ActionsList-post",
  ACTIONS_POINTS_DROPDOWN: "action-pointsDropdown-post",
  CHANGE_ACTIONS: "actions-changeActions-patch",
  DELETE_ACTIONS: "actions-deleteActions-delete",
  EDIT_ACTIONS: "actions-editActions-put",
  //caregory ==> benefit
  ADD_BENEFIT_DATA: "benefit-addBenefitData-post",
  BENEFIT_LIST: "benefit-BenefitList-post",
  CHANGE_BENEFIT: "benefit-changeBenefit-patch",
  DELETE_BENEFIT: "benefit-deleteBenefit-delete",
  EDIT_BENEFIT: "benefit-editBenefit-put",
  FILE_UPLOAD_BENEFITS: "benefit-uploadBenefit-post",
  CHANGE_WORKER_BENEFIT: "benefit-change-worker-Benefit-patch",

  //caregory ==> que type
  ADD_QUE_TYPE_DATA: "queType-addQueTypeData-post",
  QUE_TYPE_LIST: "queType-QueTypeList-post",
  CHANGE_QUE_TYPE: "queType-changeQueType-patch",
  DELETE_QUE_TYPE: "queType-deleteQueType-delete",
  EDIT_QUE_TYPE: "queType-editQueType-put",
  FILE_UPLOAD_QUE_TYPE: "queType-uploadQueType-post",

  GENDER_LIST: "genderMix-getGenderMixData-post",
  EDIT_GENDER: "gender-editGender-put",
  FILE_UPLOAD_GENDER: "gender-uploadGender-post",

  //caregory ==> atmospahre Ranges
  ADD_ATMOSPHARE_DATA: "atmosphare-addAtmosphareData-post",
  ATMOSPHARE_LIST: "atmosphare-AtmosphareList-post",
  CHANGE_ATMOSPHARE: "atmosphare-changeAtmosphare-patch",
  DELETE_ATMOSPHARE: "atmosphare-deleteAtmosphare-delete",
  EDIT_ATMOSPHARE: "atmosphare-editAtmosphare-put",
  FILE_UPLOAD_ATMOSPHARE: "atmosphare-uploadAtmosphare-post",
  GET_LATEST_ATMOSPHARE: "atmosphare-getlatestAtmosphare-get",

  //clubs
  FILE_UPLOAD_CLUB: "clubs-uploadClubs-post",
  FILE_UPLOAD_MINI_CLUB: "clubs-upload-MiniClubs-post",
  ADD_CLUBS_DATA: "clubs-addClubs-post",
  CLUB_DATA: "clubs-listClubs-post",
  CLUB_ADMIN_DATA: "clubs-adminlistClubs-post",
  DELETE_CLUB_DATA: "clubs-deleteClubs-delete",
  UPDATE_CLUBS_STATUS: "clubs-updateClubs-put",
  CHANGE_CLUB_STATUS: "clubs-changeClubs-put",
  CLUB_DETAILS_DOWNLOAD: "clubs-clubDetailsDownload-get",
  CLUBS_ADMIN_LIST: "clubs-adminsClubList-post",
  CLUBS_POST_LIST: "postClubs-postClubList-post",
  CLUBS_POST_ADD: "postClubs-addPostClub-post",
  CLUBS_POST_EDIT: "postClubs-editPostClub-put",
  CLUBS_POST_DELETE: "postClubs-deletePostClub-delete",
  FILE_UPLOAD_CLUBS_POST: "postClubs-uploadPostClub-post",
  ADD_CLUBS_WEEK: "clubs-addClubWeek-post",
  EDIT_CLUB_PROFILE: "clubs-editClubProfile-put",
  ADD_UPDATE_CLUBS_FALSE_VOY: "clubs-addUpdateFalseVoy-post",
  CLUB_DETAILS: "clubs-detailsClub-get",
  CLUBS_WEEK_LIST: "clubs-weekList-post",
  CLUBS_WEEK_DETAILS_LIST: "clubs-week-details-List-post",
  EDIT_CLUB_WEEK: "clubs-editClubWeek-put",
  EDIT_MULTI_CLUB_WEEK: "clubs-editMultiClubWeek-put",
  DELETE_MUSIC_TYPE_WEEK: "clubs-deleteMusicTypeWeek-delete",
  DELETE_OUTFIT_WEEK: "clubs-deleteOutfitWeek-delete",
  ADD_OUTFIT_WEEK: "clubs-addOutfitWeek-post",
  ADD_MUSIC_TYPE_WEEK: "clubs-deleteMusicTypeWeek-post",
  CLUB_BENEFIT_FILE_UPLOAD: "clubs-benefitsFileUpload-post",
  CLUB_BENEFIT_ADD: "clubs-benefitsAdd-post",
  SAVE_CLUB_BENEFIT_DATA: "club-saveBenefitsAdd-post",
  CLUB_BENEFITS_ACTION_POINTS: "club-benefits-actions-get",
  SAVE_CLUB_BENEFIT_LISTING: "club-benefits-actionSavedList-get",
  CLUB_LEVEL_BENEFIT_LIST: "club-level-benefitsList-get",
  ADD_CLUB_FALSE_VOY: "club-addFalseVoy-post",
  EDIT_CLUBS_FALSE_VOY: "club-editFalseVoy-put",
  CLUB_LEVEL_WISE_USER: "club-levelWise-user-get",
  CLUB_TOP_USER: "club-topUser-user-get",
  CLUB_USERS_STATS: "club-userStats-get",
  CLUB_NAME_DROPDOWN: "club-clubNameDropdown-get",
  CLUBS_ADMIN_NAME_LIST: "club-clubAdminClubNameList-get",
  GET_BEST_THE_DAYS: "club-getBestTheDays-post",
  GET_THE_BEST_DAYS_DATA: "club-getTheBestDaysData-get",
  ADD_CLUB_NEW_CO_OWNER: "club-addClubNewCoOwner-post",
  GET_CLUB_CO_OWNER_EMAIL: "club-getClubCoOwnerEmail-get",

  //reports
  ADMIN_REPORT_DATA: "reports-adminReportData-post",
  ADMIN_REPORT_DOWNLOAD: "reports-adminReportDownload-get",
  USER_REPORT_DATA: "reports-userReportData-post",
  USER_REPORT_DOWNLOAD: "reports-userReportDownload-get",
  CLUB_REPORT_DATA: "reports-clubReportData-post",
  CLUB_REPORT_DOWNLOAD: "reports-clubReportDownload-get",
  BRAND_REPORT_DATA: "reports-brandReportData-post",
  BRAND_REPORT_DOWNLOAD: "reports-brandReportDownload-get",
  TEMPLATE_DATA: "reports-templateData-post",

  //brand
  ADD_BRAND: "brand-addBrand-post",
  BRAND_LIST: "brand-listBrand-post",
  UPLOAD_BRAND_IMAGES: "brand-brandFileUpload-post",
  CHANGE_BRAND: "brand-changeBrandStatus-patch",
  DELETE_BRAND: "brand-deleteBrand-delete",
  BRAND_DETAILS_DOWNLOAD: "brand-detailsDownload-get",
  EDIT_BRAND_PROFILE: "edit-brandProfile-put",
  GET_BRAND_PROFILE: "get-brandPofileDetails-get",
  BRAND_ADMIN_LIST: "brand-brandAdminList-post",
  BRAND_ACTION_POINTS_LISTING: "brand-brandActionPointsList-get",
  BRAND_SAVE_BENEFITS: "brand-saveBrandBenefits-post",
  BRAND_FILE_UPLOAD: "brand-benefitsFileUpload-post",
  BRAND_BENEFITS_MAPPING: "brand-benefitsMapping-post",
  BRAND_BENEFITS_LISTING: "brand-benefitsListing-post",
  BRAND_SAVED_BENEFITS_LISTING: "brand-savedBrandBenefitsList-post",
  BRAND_NAME_DROPDOWN: "brand-brandNameDropdown-get",
  BRAND_INCREASE_TAG_COUNT: "brand-increaseTagCount-post",
  BRAND_DECREASE_TAG_COUNT: "brand-decreaseTagCount-post",
  BRAND_ADMIN_BRAND_NAME_DROPDOWN: "brand-brandAdminNameDropdown-get",
  BRAND_SUBSCRIBERS_LIST: "brand-subscriberList-get",
  BRAND_SUBSCRIBERS_LIST_DOWNLOAD: "brand-subscriberListDownload-get",
  ADD_BRAND_NEW_CO_OWNER: "club-addBrandNewCoOwner-post",
  GET_BRAND_CO_OWNER_EMAIL: "club-getBrandCoOwnerEmail-get",

  //surveys
  BRAND_SURVEYS_LIST: "brand-listBrandSurvey-post",
  ADD_SURVEY_BRAND: "brand-addSurveyBrand-post",
  EDIT_SURVEY_BRAND: "brand-editSurveyBrand-post",
  DELETE_SURVEY_BRAND: "brand-deleteSurveyBrand-delete",
  GET_BRAND_SURVEY_DETAILS: "brand-getBrandSurveyDetails-get",
  BRAND_THE_BEST: "brand-brandTheBest-patch",

  //Addpromotion
  ADD_PROMOTION: "managePromotion-addPromotion-post",
  EDIT_PROMOTION: "managePromotion-editPromotion-put",
  DELETE_PROMOTION: "managePromotion-deletePromotion-delete",
  PROMOTION_LISTING: "managePromotion-listPromotion-post",
  PROMOTION_DETAILS: "managePromotion-detailsPromotion-get",
  GET_ALL_BENEFITS_LISTING_DATA:
    "managePromotion-getAllBenefitsListingData-post",

  //dashboard
  DASHBOARD_SUPER_ADMIN: "dashboard-superAdminDashboard-post",
  DASHBOARD_CLUB_ADMIN: "dashboard-clubAdminDashboard-post",
  DASHBOARD_BRAND_ADMIN: "dashboard-brandAdminDashboard-post",

  //Workers
  WORKERS_LIST: "worker-workersList-post",
  ADD_WORKER: "worker-addWorker-post",
  CHANGE_WORKER: "worker-changeStatusWorker-patch",
  DELETE_WORKER: "worker-deleteWorker-delete",
  UPDATE_WORKER_DETAILS: "worker-updateWorkerDetails-put",
  WORKER_DETAILS_GET: "worker-workerDetails-get",
  WORKER_DETAILS_DOWNLOAD: "worker-workerDetailsDownload-get",
  GET_USERS_FAV_CLUBS: "worker-workerGetUserFavClubs-post",
  GET_USERS_MOST_VOY_CLUB: "worker-workerGetUserMostVoyClub-post",
  GET_USERS_TOP_LEVEL_CLUB: "worker-workerGetUserTopLevelClub-post",
  GET_USERS_BENEFIT_REDEEMED: "worker-workerGetUserBenefitRedeemedClub-post",
  BENEFITS_WORKER_LIST: "worker-benefits-get",
  BENEFITS_ACCORDING_WORKER_LIST: "worker-according-benefits-post",

  //fourvenues
  FOURVENUES_ORG_LIST: "fourvenues-orgList-get",
};
